import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { CommonStyles } from '~commonInfra/styles/CommonStyles';
import { getLinkMarkup, ILink } from '~src/spacesPlatform/components/ListView/dataGridCells/LinkCell';
import { StyledCellFormatter } from '~src/spacesPlatform/components/ListView/StyledCellWrapper';

import { SiteRolesHelper } from '../../../../siteManagement/helpers/SiteRolesHelper';
import { ProfilePictureStyles } from '../../../components/styles/ProfilePictureStyles';
import { DataGridProfilePicture } from '../../../components/userProfilePicture/DataGridProfilePicture';
import { IGroupInfo } from '../../models/IGroupInfo';
import { GrantLicenseModes } from '../../serverApi/requests/SyncActiveDirectoryGroupRequest';

export namespace GroupDataGridCells {

  export function ProfilePictureCell(
      getProfileProps: (row: DataGrid.Row) => DataGridProfilePicture.Props,
      getLinkOptions: (row: DataGrid.Row) => ILink
    ): React.StatelessComponent<BodyCell.Props> {
    return StyledCellFormatter(function ProfilePictureCells(props: BodyCell.Props) {
      const linkOptions = getLinkOptions(props.row);
      return (
        <div style={ProfilePictureStyles.Layout.GroupNameWithProfilePictureCellWrapperStyle}>
          <span style={ProfilePictureStyles.Layout.GroupNameWithProfilePictureCellChildStyle}>
            <DataGridProfilePicture {...getProfileProps(props.row)} />
          </span>
          <span style={ProfilePictureStyles.Layout.GroupNameWithProfilePictureCellChildDisplayNameStyle}>
            <span data-tb-test-id={linkOptions.testId} style={CommonStyles.Layout.FlexBlockLeftAndCenter}>
              {getLinkMarkup(linkOptions, props.row)}
            </span>
          </span>
        </div>
      );
    });
  }

  export function MinimumSiteRoleCell(): React.StatelessComponent<BodyCell.Props> {
    return StyledCellFormatter(function generateSiteRoleName(props: BodyCell.Props) {
      const group = props.row.data as IGroupInfo;
      let siteRole: string = group.minimumSiteRole ? SiteRolesHelper.siteRoleToName(group.minimumSiteRole) : '';
      if (FeatureFlags.licenseUponLoginEnabled && group
          && (group.grantLicenseMode === undefined || group.grantLicenseMode !== GrantLicenseModes.ON_LOGIN)
          && (group.domainName === undefined || group.domainName === 'local')) {
          siteRole = '';
      }
      return (
        <div>{siteRole}</div>
      );
    });
  }
}
